module.exports = __webpack_public_path__ + "22a552cb1d9be65ad95b5ea612530d52.svg";